import { meterClass, riskWidth } from '@/lib/format'
import type { RiskLevel } from '@/types/dashboard'

export function RiskMeter({ level }: { level: RiskLevel }) {
  return (
    <div className={`meter ${meterClass(level)}`}>
      <i style={{ width: `${riskWidth(level)}%` }} />
    </div>
  )
}
